import { Box, BoxProps } from "@chakra-ui/react";
import { MdLeaderboard } from "react-icons/md";
import { BsFillAwardFill } from "react-icons/bs";
import { IoMdNotifications } from "react-icons/io";
import { MAX_NAVBAR_WIDTH } from "../config";
import { NavBarItem } from "./NavBarItem";
import { useAPI } from "../api/useAPI";
import { useEffect } from "react";
import { useBehaviorSubjectState } from "../utils/useBehaviorSubjectState";
import { FaCalendar } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";

interface NavBarProps {
  children?: any;
  height: BoxProps["height"];
}

export const NavBar = ({ children, height }: NavBarProps) => {
  const api = useAPI();
  const [notificationCount] = useBehaviorSubjectState(api.notificationCount$);

  useEffect(() => {
    api.listenToNotifications();
  }, [api]);

  return (
    <Box
      backgroundColor={"gray.100"}
      boxShadow={"base"}
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
      width={"100%"}
      position={"fixed"}
      bottom={0}
      height={height}
    >
      <Box width={"100%"} display={"flex"} maxW={MAX_NAVBAR_WIDTH}>
        {children ? (
          children
        ) : (
          <>
            <NavBarItem
              icon={<FaCalendar />}
              url="/schedule"
              label="Schedule"
            />
            <NavBarItem
              icon={<MdLeaderboard />}
              url={"/leaderboard"}
              label={"Leaderboard"}
            />
            <NavBarItem
              icon={<BsFillAwardFill />}
              url={"/award"}
              label={"Award Points"}
            />
            <NavBarItem
              icon={
                <Box position={"relative"}>
                  {notificationCount > 0 ? (
                    <Box
                      position={"absolute"}
                      bottom={"50%"}
                      left={"50%"}
                      backgroundColor={"red.400"}
                      borderRadius={"full"}
                      width={"20px"}
                      height={"20px"}
                      fontSize={"small"}
                      textAlign={"center"}
                      color={"black"}
                    >
                      {notificationCount}
                    </Box>
                  ) : null}
                  <IoMdNotifications />
                </Box>
              }
              url={"/notifications"}
              label={"Notifications"}
            />
            <NavBarItem icon={<IoSearch />} url={"/people"} label={"People"} />
          </>
        )}
      </Box>
    </Box>
  );
};
